import { lazy } from "react";

// Lazy load all admin views
const Dashboard = lazy(() => import("@/views/admin/Dashboard"));
const AdminProducts = lazy(() => import("@/views/admin/Products"));
const AdminOrders = lazy(() => import("@/views/admin/Orders"));
const AdminUsers = lazy(() => import("@/views/admin/Users"));
const AdminCategories = lazy(() => import("@/views/admin/Categories"));
const AdminSettings = lazy(() => import("@/views/admin/Settings"));
const AdminOffers = lazy(() => import("@/views/admin/Offers"));
const AdminAnalytics = lazy(() => import("@/views/admin/Analytics"));
const AdminSales = lazy(() => import("@/views/admin/Sales"));

/**
 * Admin Routes Configuration
 * All admin routes require authentication
 */
export const adminRoutes = [
  {
    path: "/admin",
    element: Dashboard,
    protected: true,
    title: "Dashboard - Admin Panel",
  },
  {
    path: "/admin/products",
    element: AdminProducts,
    protected: true,
    title: "Products - Admin Panel",
  },
  {
    path: "/admin/orders",
    element: AdminOrders,
    protected: true,
    title: "Orders - Admin Panel",
  },
  {
    path: "/admin/users",
    element: AdminUsers,
    protected: true,
    title: "Users - Admin Panel",
  },
  {
    path: "/admin/categories",
    element: AdminCategories,
    protected: true,
    title: "Categories - Admin Panel",
  },
  {
    path: "/admin/offers",
    element: AdminOffers,
    protected: true,
    title: "Offers - Admin Panel",
  },
  {
    path: "/admin/analytics",
    element: AdminAnalytics,
    protected: true,
    title: "Analytics - Admin Panel",
  },
  {
    path: "/admin/sales",
    element: AdminSales,
    protected: true,
    title: "Sales - Admin Panel",
  },
  {
    path: "/admin/settings",
    element: AdminSettings,
    protected: true,
    title: "Settings - Admin Panel",
  },
  // {
  //   path: "/admin/system-settings",
  //   element: lazy(() => import("@/views/admin/SystemSettings")),
  //   protected: true,
  //   title: "System Settings - Admin Panel",
  // },
];

export default adminRoutes;
